import StudentsPage from "../../../admin/pages/studentsPage/StudentsPage";
import TeachersPage from "../../../admin/pages/teachersPage/TeachersPage";
import EventsPage from "../../../admin/pages/eventsPage/EventsPage";
import CamerasPage from "../../../admin/pages/camerasPage/CamerasPage";
import StatisticsPage from "../../../admin/pages/statisticsPage/StatisticsPage";

export const adminPanelRoutes = [
  {
    text: "Statistics",
    path: "/admin-panel/statistics",
    exact: true,
    element: <StatisticsPage />,
  },
  {
    text: "Admin panel",
    path: "/admin-panel/teachers",
    exact: true,
    element: <TeachersPage />,
  },
  {
    text: "Students",
    path: "/admin-panel/students",
    exact: true,
    element: <StudentsPage />,
  },
  {
    text: "Admin panel",
    path: "/admin-panel/events",
    exact: true,
    element: <EventsPage />,
  },
  {
    text: "Students",
    path: "/admin-panel/cameras",
    exact: true,
    element: <CamerasPage />,
  },
];
